// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

import { ValidacaoProprietario } from "../interfaces/ValidacaoProprietario";

export const atualizarEnderecoService = async (
  enderecoId: number | undefined,
  atualizarEnderecoUsuario: ValidacaoProprietario
) => {
  const Token = validateToken();
  const values = {
    ...atualizarEnderecoUsuario,
    enderecoId: enderecoId,
  };
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/endereco`;
    try {
      const response = await axios.put(URL, values, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }
};
